import _ from "lodash";
import React, { useEffect, useRef } from "react";
import classes from "./EvaluationCycles.scss";
import { styles } from "./EvaluationCyclesStyles";
import CycleCard from "AppComponents/SnPCyclesFeed/CycleCard";
import { KeyboardNavigableList } from "UIComponents/KeyboardNavigableList";
import ArrowWithCount from "./ArrowWithCount";
import { SearchInput } from "@toddle-edu/ds-web";

const BLANK_OBJECT = {};
const EvaluationCycles = props => {
  const {
    updateCurrentCycle,
    cycles,
    closeButtonElement,
    t,
    cycleIdToTaggedPracticesCountMapping,
    showDesignV2,
    isGlobalHeaderOnMultipleScreensEnabled,
    testId,
  } = props;
  const cyclesScrollContainerRef = useRef(null);

  const totalCycles = _.size(cycles);

  const firstCycleId = _.get(_.first(cycles), "id", "");

  useEffect(() => {
    /**To show Practices when there is only 1 cycle */
    if (totalCycles === 1) updateCurrentCycle({ id: firstCycleId });
  }, [totalCycles, firstCycleId, updateCurrentCycle]);

  const [searchTextForCycles, setSearchTextForCycles] = React.useState("");

  const filteredCycles = _.filter(cycles, cycle => {
    return _.includes(_.toLower(cycle?.title), _.toLower(searchTextForCycles));
  });

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.title}>{`${t("common:tag_snp")}`}</div>
        {closeButtonElement}
      </div>
      <div className={classes.subHeader}>{t("snp:select_cycle")}</div>
      <div className={classes.searchContainer}>
        <SearchInput
          size="large"
          onChange={setSearchTextForCycles}
          placeholder={t("common:search_for_with_label", {
            label: t("snp:cycle_plural"),
          })}
          dsVersion={isGlobalHeaderOnMultipleScreensEnabled ? "2.0" : "1.0"}
          focusSearchBySlash={isGlobalHeaderOnMultipleScreensEnabled}
          testId={`${testId}-evaluationCycles`}
        />
      </div>
      <div className={classes.cyclesContainer}>
        <KeyboardNavigableList listContainerRef={cyclesScrollContainerRef}>
          <div
            className={classes.cyclesScrollContainer}
            ref={cyclesScrollContainerRef}
          >
            {_.map(filteredCycles, cycle => {
              return (
                <CycleCard
                  key={cycle.id}
                  cycle={cycle}
                  testId={testId}
                  onClickCard={updateCurrentCycle}
                  cardStyles={
                    showDesignV2 ? styles.cardStylesV2 : styles.cardStyles
                  }
                  cycleActionsElement={
                    <ArrowWithCount
                      testId={testId}
                      count={cycleIdToTaggedPracticesCountMapping[cycle.id]}
                      countStyle={
                        showDesignV2 ? styles.arrowWithCountStyle : BLANK_OBJECT
                      }
                    />
                  }
                  showDesignV2={showDesignV2}
                />
              );
            })}
          </div>
        </KeyboardNavigableList>
      </div>
    </div>
  );
};

export default EvaluationCycles;
